const HAULAGE_JOBS = () => `/jobs/haulage`
const HAULAGE_JOBS_BY_ID = (id: string) => `${HAULAGE_JOBS()}/${id}`
export const HAULAGE_JOB_EXPORT = () => `${HAULAGE_JOBS()}/export`

export default {
  HAULAGE_JOBS,
  HAULAGE_JOBS_BY_ID,
  HAULAGE_JOB_EXPORT
}
